export function coerceSearchToBoolean(val: unknown): boolean {
  if (typeof val === 'boolean') return val;

  if (val === 'true') return true;
  if (val === '') return true; // Handle case where presence of the parameter (without value) should be considered true

  return false;
}
